import { Button } from "antd";
import PlayIcon from "../../../assets/web/icons/PlayIcon";
import Shape8 from "../../../assets/web/images/shape-8.svg";
import Shape9 from "../../../assets/web/images/shape-9.svg";
import BannerContainer from "../../../components/web/common/BannerContainer";
import PricingCards from "../../../components/web/common/PricingCards";
import PrimaryButton from "../../../components/web/PrimaryButton";
import Award from "../../../components/web/productDetails/Award";
import ProductFeatures from "../../../components/web/productDetails/ProductFeatures";
import PublicLayout from "../../../layouts/PublicLayout";

export default function ProductDetails() {
  return (
    <PublicLayout title="Product Details | Sheba Business Portal">
      <BannerContainer>
        <div className="text-4xl md:text-6xl font-bold text-center text-textHeading">
          <span className="md:block">Your central hub for</span>{" "}
          <span className="md:block">
            all{" "}
            <span className="relative">
              <span>employee</span>
              <img
                src={Shape8}
                className="absolute -bottom-[5px] left-[25px] -z-10"
              />
            </span>{" "}
            information.
          </span>
        </div>
        <div className="text-[22px] text-center mt-2">
          <span className="md:block">
            <span className="text-webPrimary">DigiGo Employees app</span> goes
            beyond being just a staff directory—it's a
          </span>{" "}
          comprehensive hub for all your HR needs.
        </div>

        <div className="flex gap-3 justify-center mt-8">
          <PrimaryButton>Start now - it’s free</PrimaryButton>
          <Button className="bg-lightPrimary text-webPrimary border-0 ring-0 rounded-full h-9 w-9 flex justify-center items-center">
            <PlayIcon />
          </Button>
        </div>
      </BannerContainer>
      <Award />

      {/* <section className="bg-[#FFF9F6] py-16">
        <FeatureItem
          title="Track Attendance & Get Report Smoothly"
          imagePosition="right"
          imageUrl={ProductFeature1}
        >
          {[
            "Track all types of employee attendance easily",
            "Days off are scheduled automatically",
            "Location based, remote or office Wi-Fi attendance",
            "Real-time Reports",
          ].map((point, index) => (
            <FeatureBulletPoint key={index} title={point} />
          ))}
        </FeatureItem>
        <FeatureItem
          title="Apply & Approve Leave At One Click"
          imagePosition="left"
          imageUrl={ProductFeature2}
        >
          {[
            "Reduce stress by applying & approving Leave in mobile ",
            "Relief extra tension of prorating leave",
            "Get customized reports",
          ].map((point, index) => (
            <FeatureBulletPoint key={index} title={point} />
          ))}
        </FeatureItem>
        <FeatureItem
          title="Disburse Salary & Get Pay Report Instantly"
          imagePosition="right"
          imageUrl={ProductFeature3}
        >
          {[
            "Reduce chances of mistakes through auto-calculation",
            "Tax calculation has never been this easy",
            "Edit any item anytime",
          ].map((point, index) => (
            <FeatureBulletPoint key={index} title={point} />
          ))}
        </FeatureItem>
        <FeatureItem
          title="Submit Expenses Just In Few Clicks"
          imagePosition="left"
          imageUrl={ProductFeature4}
        >
          {[
            "Reduce employees expenses by tracking efficiently",
            "Multiple cost categories to prepare report",
            "Download & submit anytime",
          ].map((point, index) => (
            <FeatureBulletPoint key={index} title={point} />
          ))}
        </FeatureItem>
        <FeatureItem
          title="Get Employee Meeting Locations Quickly"
          imagePosition="right"
          imageUrl={ProductFeature5}
        >
          {[
            "Track employee meeting location for better transparency",
            "Check visit report instantly",
            "Increase growth team's productivity",
          ].map((point, index) => (
            <FeatureBulletPoint key={index} title={point} />
          ))}
        </FeatureItem>
        <FeatureItem
          title="Updated Team Report At Once"
          imagePosition="left"
          imageUrl={ProductFeature6}
        >
          {[
            "Keep eyes on employee performance",
            "Get report summary in one view",
            "Make instant decision based on reports",
          ].map((point, index) => (
            <FeatureBulletPoint key={index} title={point} />
          ))}
        </FeatureItem>
      </section> */}
      <ProductFeatures />
      <section className="py-16">
        <div className="text-4xl text-[#001652] text-center font-semibold">
          You are not{" "}
          <span className="relative">
            dreaming!
            <img src={Shape9} alt="" className="absolute left-0 bottom-0" />
          </span>
        </div>
        <PricingCards />
      </section>
    </PublicLayout>
  );
}
